angular.module('pitch.app').controller('LoginCtrl',
    function($scope, $window, $location, LoginModal, $state) {

        "use strict";

        var search = $location.search();

        $state.go('home', {}, { reload: true });

        LoginModal.open({
            preventAutoClose: true,
            success: function() {
                if (search.return) {
                    $window.location.replace(search.return);
                }
            }
        });
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/LoginCtrl.js